module.exports = __webpack_public_path__ + "static/media/shareToInstagramExample.da064dbb.png";